import { GridCellValue } from '@mui/x-data-grid'

export const BooleanSort = (a: GridCellValue, b: GridCellValue): number => {
  const aValue = a ? 1 : 0
  const bValue = b ? 1 : 0
  return aValue - bValue
}

export const NumberSort = (a: GridCellValue, b: GridCellValue): number => {
  const aStr = String(a ?? '')
  const bStr = String(b ?? '')
  const aNumber = parseInt(aStr.replace(/\D/g, '').slice(0, 2)) || 0
  const bNumber = parseInt(bStr.replace(/\D/g, '').slice(0, 2)) || 0
  return aNumber - bNumber
}

export const ArrToNumberSort = (a: GridCellValue, b: GridCellValue): number => {
  return NumberSort(String((a as any[])?.length ?? 0), String((b as any[])?.length ?? 0))
}

export const StringSort = (a: GridCellValue, b: GridCellValue): number => {
  return String(a ?? '').localeCompare(String(b ?? ''))
}
